import { render, staticRenderFns } from "./yourAgeChart.vue?vue&type=template&id=457d9ba6&scoped=true&"
import script from "./yourAgeChart.vue?vue&type=script&lang=js&"
export * from "./yourAgeChart.vue?vue&type=script&lang=js&"
import style0 from "./yourAgeChart.vue?vue&type=style&index=0&id=457d9ba6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457d9ba6",
  null
  
)

export default component.exports